import React from 'react';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import Settings from '../pages/Settings';
import useTranslation from '../services/translationService';

const SettingsModal = ({ isOpen, onClose, onSignOut }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    // Sits between the app header (40) and the tab bar (45) so the tab bar stays usable while settings is open
    <div className="fixed inset-0 z-[42] overflow-y-auto" aria-labelledby="settings-modal" role="dialog" aria-modal="true">
      {/* Full screen modal without centering wrapper */}
      <div className="min-h-screen">
        {/* Background overlay */}
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 dark:bg-opacity-70 transition-opacity" 
          aria-hidden="true" 
        ></div>
        
        {/* Full screen modal panel */}
        <div className="fixed inset-0 bg-gray-50 dark:bg-gray-900 overflow-y-auto">
          {/* Header with back button */}
          <div className="sticky top-0 z-10 bg-white/90 dark:bg-gray-900/85 backdrop-blur-md border-b border-gray-200/70 dark:border-white/10 px-4 pb-2 pt-[calc(env(safe-area-inset-top)+0.5rem)]">
            <div className="max-w-3xl mx-auto flex items-center">
              <button
                onClick={onClose}
                className="-ms-2 flex items-center gap-2 px-3 py-2 rounded-lg bg-transparent dark:bg-transparent hover:bg-gray-100 dark:hover:bg-white/10 text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-gray-100 transition-colors duration-200 group"
                aria-label={t('common.back')}
              >
                <ArrowLeftIcon className="h-5 w-5 group-hover:-translate-x-0.5 transition-transform duration-200" />
                <span className="font-medium">{t('common.back')}</span>
              </button>
            </div>
          </div>

          {/* Settings content */}
          <Settings onSignOut={onSignOut} isModal={true} onClose={onClose} />
        </div>
      </div>
    </div>
  );
};

export default SettingsModal; 